import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BarcodeScannerComponent } from 'src/app/base/shared/barcode-scanner/barcode-scanner.component';
import { FastCheckinParkingSessionInfoDTO } from 'src/app/base/models/models.swagger.generated';
import { TagType } from '../../administration/parker-administration/edit-parker-form/edit-parker-edit-tag-list-form/tag-type.enum';
import { QueryParameter } from 'src/app/base/query-parameters';

@Component({
  selector: 'app-fast-checkin-session-visitor-activation',
  templateUrl: './fast-checkin-session-visitor-activation.component.html',
  styleUrls: ['./fast-checkin-session-visitor-activation.component.scss'],
  imports: [TranslateModule, BarcodeScannerComponent]
})
export class FastCheckinSessionVisitorActivationComponent implements OnInit {
  @Input() public sessionInfo: FastCheckinParkingSessionInfoDTO;
  @Output() public validateParkingCard = new EventEmitter<string>();
  @Output() public checkOut = new EventEmitter<void>();
  public showError: boolean = false;
  public errorMessage: string = '';
  public TagType = TagType;
  public showQrText = false;

  constructor() { }

  ngOnInit() {
  }

  public onQrScanned(qrData: string): void {
    console.log('QR Data scanned: ' + qrData);
    try {
      const url = new URL(qrData);
      const subtype = url.searchParams.get(QueryParameter.QrCodeSubtype);
      const type = url.searchParams.get(QueryParameter.QrCodeType);
      const id = url.searchParams.get(QueryParameter.QrCodeId);

      if (type !== 'V' || subtype !== 'p' || !id) {
        this.showError = true;
        this.errorMessage = 'Invalid QR code format'; // TODO
        return;
      }
      this.validateParkingCard.emit(id);
    } catch (e) {
      this.showError = true;
      this.errorMessage = 'Invalid QR code format';
    }
  }

}
